// extracted by mini-css-extract-plugin
export default {"students":"AboutHeaderLinks_students__l+5FT","aafterIcon":"AboutHeaderLinks_aafterIcon__tQvD6","text":"AboutHeaderLinks_text__CZYkm","a":"AboutHeaderLinks_a__hcOjw"};